import { lumi } from '@/lib/lumi'
import type { StaffRole } from '@/types/author'

const SESSION_KEY = 'bonita_admin_session'
const SESSION_USER_KEY = 'bonita_admin_user'
const SESSION_ROLE_KEY = 'bonita_admin_role'
const SESSION_FULL_NAME_KEY = 'bonita_admin_full_name'

export const BUILTIN_ADMIN = {
  username: 'Admin',
  password: 'Admin200%',
} as const

function persistSession(username: string, role: StaffRole, fullName: string) {
  window.localStorage.setItem(SESSION_KEY, '1')
  window.localStorage.setItem(SESSION_USER_KEY, username)
  window.localStorage.setItem(SESSION_ROLE_KEY, role)
  window.localStorage.setItem(SESSION_FULL_NAME_KEY, fullName)
}

export function isAdminSession(): boolean {
  try {
    return window.localStorage.getItem(SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function getAdminName(): string {
  try {
    return window.localStorage.getItem(SESSION_USER_KEY) || BUILTIN_ADMIN.username
  } catch {
    return BUILTIN_ADMIN.username
  }
}

export function getStaffRole(): StaffRole {
  try {
    const role = window.localStorage.getItem(SESSION_ROLE_KEY)
    return role === 'author' ? 'author' : 'admin'
  } catch {
    return 'admin'
  }
}

export function getStaffFullName(): string {
  try {
    return window.localStorage.getItem(SESSION_FULL_NAME_KEY) || getAdminName()
  } catch {
    return getAdminName()
  }
}

export async function loginAdmin(username: string, password: string): Promise<boolean> {
  const user = username.trim()
  if (user === BUILTIN_ADMIN.username && password === BUILTIN_ADMIN.password) {
    persistSession(BUILTIN_ADMIN.username, 'admin', 'Administrador')
    return true
  }

  try {
    const { list } = await lumi.entities.authors.list({
      filter: { username: user },
      limit: 20,
    })
    const match = (list || []).find((item: { username?: string; password?: string; active?: boolean; fullName?: string }) => {
      const sameUser = (item?.username || '').trim().toLowerCase() === user.toLowerCase()
      const samePass = item?.password === password
      const isActive = item?.active !== false
      return sameUser && samePass && isActive
    })
    if (!match) return false
    persistSession(match.username || user, 'author', match.fullName || user)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

export function logoutAdmin(): void {
  window.localStorage.removeItem(SESSION_KEY)
  window.localStorage.removeItem(SESSION_USER_KEY)
  window.localStorage.removeItem(SESSION_ROLE_KEY)
  window.localStorage.removeItem(SESSION_FULL_NAME_KEY)
}

export function maskSecret(value?: string | null) {
  const text = (value || '').trim()
  if (!text) return ''
  return '********'
}
